<template>
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-form-item>
              <el-select v-model="filters.value" placeholder="请选择">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-input v-model="filters.name" placeholder="用户昵称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="currentPage=1,getFeedBack()">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-table
        :data="tableData"
        style="width: 100%">
        <el-table-column
          label="序号"
          type="index"
          width="70">
        </el-table-column>
        <el-table-column
          label="用户昵称"
          prop="userName">
        </el-table-column>
        <el-table-column
          label="联系方式"
          prop="phone">
        </el-table-column>
        <el-table-column
          label="反馈时间"
          :formatter="formatDate"
          prop="insertTime">
        </el-table-column>
        <el-table-column
          label="联系者"
          prop="operatorName">
        </el-table-column>
        <el-table-column
          :formatter="formatDate1"
          label="解决时间"
          prop="updateTime">
        </el-table-column>
        <el-table-column
          label="问题状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state ==0">未解决</span>
            <span v-if="scope.row.state ==1">已解决</span>
            </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row.id)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import headTop from '../components/headTop'
  import { getFeedBack} from "../api/api"
  import { formatDate } from "../api/formatDate"
  export default {
    data () {
      return {
        filters: {
          value: '',
          name: ''
        },
        addForm:{
          textarea:''
        },
        options:[{
          value: ' ',
          label: '全部',
        }, {
          value: '0',
          label: '未解决',
        }, {
          value: '1',
          label: '已解决',
        }],
        tableData: [],
        limit: 20,
        total: 0,
        currentPage: 1,
        codedata:[],
        id:'',
        remark:''
      }
    },
    components: {
      headTop,
    },
    methods: {
      //时间戳转换
      formatDate(value) {
        var date = new Date(value.insertTime*1000);
        return formatDate(date, 'yyyy-MM-dd h:m:s');
      },
      formatDate1(value) {
        var date = new Date(value.updateTime*1000);
        return formatDate(date, 'yyyy-MM-dd h:m:s');
      },
      getFeedBack(){
        getFeedBack({
          pageNum:this.currentPage,
          pageSize:this.limit,
          state :this.filters.value,
          userName:this.filters.name,
        }).then(res=>{
          this.total = res.total
          this.tableData = res.data.pageInfo
        }).catch(error=>{
          console.log(error);
        })
      },
      handleEdit(id){
        this.$router.push({
          path: 'feeddetail',
          query:{id:id}
        });
      },
      handleCurrentChange (val) {
        this.currentPage = val;
        this.getFeedBack()
      },
    },
    activated (){
      this.getFeedBack()
    },
  }
</script>

<style lang="less">
  @import '../style/mixin';
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>




// WEBPACK FOOTER //
// src/page/feedback.vue